import { render, staticRenderFns } from "./AboutProjectInfo.vue?vue&type=template&id=4fbf197e"
import script from "./AboutProjectInfo.vue?vue&type=script&lang=ts"
export * from "./AboutProjectInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports